import React from "react";

const UpdateProfileDialogBox = ({
  title = "Edit Profile",
  contactDetailsTitle = "Contact Details",
  firstNameLabel = "First Name",
  mobileNumberLabel = "Mobile Number",
  emailLabel = "Email ID",
  firstName,
  mobileNumber,
  email,
  onFirstNameChange,
  onSave,
  onCancel,
  disableMobile = true,
  disableEmail = true,
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="max-w-md w-full bg-white p-6 rounded-[8px] shadow-lg relative">
        {/* Header */}
        <div className="flex items-center mb-6">
          <button
            onClick={onCancel}
            className="text-xl text-gray-800 font-semibold mr-2"
          >
            ←
          </button>
          <h2 className="text-lg font-semibold text-gray-900 uppercase tracking-wide">
            {title}
          </h2>
        </div>

        {/* Contact Details */}
        <div>
          <p className="text-sm font-semibold text-gray-800 mb-4">
            {contactDetailsTitle}
          </p>

          {/* First Name */}
          <label className="block text-sm text-gray-700 mb-1">
            {firstNameLabel}
          </label>
          <input
            type="text"
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-1 focus:ring-orange-500 font-semibold text-gray-900"
          />

          {/* Mobile Number */}
          <label className="block text-sm text-gray-700 mb-1">
            {mobileNumberLabel}
          </label>
          <input
            type="text"
            value={mobileNumber}
            disabled={disableMobile}
            className="w-full border border-gray-300 rounded-md px-3 py-2 mb-1 text-gray-500 bg-gray-100 font-semibold"
          />
          <p className="text-xs text-gray-500 mb-4">
            Mobile number used for login can’t be changed
          </p>

          {/* Email */}
          <label className="block text-sm text-gray-700 mb-1">
            {emailLabel}
          </label>
          <input
            type="email"
            value={email}
            disabled={disableEmail}
            className="w-full border border-gray-300 rounded-md px-3 py-2 mb-1 text-gray-500 bg-gray-100 font-semibold"
          />
          <p className="text-xs text-gray-500 mb-6">
            Mobile number used for login can’t be changed
          </p>

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="w-1/2 border border-primary-default text-orange-500 font-semibold py-2 rounded-md hover:bg-orange-50 transition uppercase"
            >
              Cancel
            </button>
            <button
              onClick={onSave}
              className="w-1/2 bg-primary-default text-white font-semibold py-2 rounded-md hover:bg-orange-600 transition uppercase"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateProfileDialogBox;